import { cn } from "@/lib/utils";
import { type CSSProperties } from "react";
import { motion } from "framer-motion";

export default function AnimatedLoading({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={cn(
        "flex-1 flex flex-col items-center justify-center min-h-full bg-[#1D2A52]",
        className
      )}
      style={style}
    >
      {/* Pixel art character */}
      <motion.img
        src="https://cdn.navalabs.io/assets/animated-loading_eluzLF.png"
        alt="Loading..."
        className="h-32 mb-4"
        style={{ imageRendering: "pixelated" }}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ 
          duration: 0.25, 
          type: "spring",
          bounce: 0.5
        }}
      />
      {/* <AnimatedWaiting prefix="Loading" className="text-xl text-white/80" /> */}
    </div>
  );
}
